import * as React from "react"
import type { SVGProps } from "react"

export const ErrorCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.236 16.764q.343 0 .576-.233a.78.78 0 0 0 .232-.575.78.78 0 0 0-.232-.576.78.78 0 0 0-.576-.232.78.78 0 0 0-.575.232.78.78 0 0 0-.233.576q0 .343.233.575a.78.78 0 0 0 .575.233m0-3.654q.32 0 .535-.216a.73.73 0 0 0 .215-.534v-4.5a.73.73 0 0 0-.216-.535.73.73 0 0 0-.534-.215.73.73 0 0 0-.534.215.73.73 0 0 0-.216.535v4.5q0 .318.216.534a.73.73 0 0 0 .534.216m.002 8.423a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.017-2.03 9.6 9.6 0 0 1-2.032-3.016 9.25 9.25 0 0 1-.748-3.705q0-1.971.748-3.705a9.6 9.6 0 0 1 2.03-3.017A9.6 9.6 0 0 1 8.53 3.281a9.25 9.25 0 0 1 3.704-.748q1.971 0 3.706.748a9.6 9.6 0 0 1 3.017 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .75 3.704q0 1.971-.749 3.705a9.6 9.6 0 0 1-2.03 3.017 9.6 9.6 0 0 1-3.016 2.032 9.25 9.25 0 0 1-3.704.748m-.002-1.5q3.35 0 5.675-2.325t2.325-5.675-2.325-5.675-5.675-2.325-5.675 2.325q-2.325 2.324-2.325 5.675t2.325 5.675 5.675 2.325"
    />
  </svg>
)
